import { SEO } from '../../utils/seo';

export default function CompanyPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: '株式会社ガイアライブラリー',
    description: 'ブロックチェーンとAIを活用し、アジアと日本の暮らしを豊かにする企業。インドネシアでのステーブルコイン事業、AI健康アプリ「クラティブ」、コーヒー輸入、防水コンクリート技術を展開。',
    url: siteUrl,
    telephone: '',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '渡辺通五丁目14番12号南天神ビル3階',
      addressLocality: '福岡市中央区',
      addressRegion: '福岡県',
      postalCode: '810-0004',
      addressCountry: 'JP'
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 33.589012,
      longitude: 130.401234
    },
    founder: {
      '@type': 'Person',
      name: '鈴山　慎一郎'
    },
    areaServed: ['JP', 'ID']
  };

  const companyInfo = [
    { label: '会社名', value: '株式会社ガイアライブラリー' },
    { label: '所在地', value: '〒810-0004 福岡県福岡市中央区渡辺通五丁目14番12号南天神ビル3階' },
    { label: '代表者', value: '鈴山　慎一郎' },
    {
      label: '事業内容',
      value: `・インドネシアにおけるステーブルコイン事業
・コーヒー等の輸入・販売事業
・AI健康・生活アプリ「クラティブ」の企画・開発・運用
・防水コンクリート等の新素材・新技術の導入支援
・その他、ブロックチェーン・AIを活用したDXコンサルティング`
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="会社概要｜福岡市中央区株式会社ガイアライブラリー"
        description="株式会社ガイアライブラリーの会社概要。福岡市中央区に本社を置き、インドネシアでのステーブルコイン事業、AI健康アプリ「クラティブ」、コーヒー輸入、防水コンクリート技術など、ブロックチェーンとAIを活用した事業を展開しています。"
        keywords="会社概要,ガイアライブラリー,福岡市中央区,企業情報,アクセス"
        schema={schema}
      />
      {/* Page Header */}
      <div className="bg-gradient-to-br from-blue-900 to-blue-700 text-white py-20 px-6 md:px-20">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-sm tracking-widest uppercase mb-4 text-blue-200">Company</p>
          <h1 className="text-4xl md:text-5xl font-bold mb-6">会社概要</h1>
          <p className="text-lg text-blue-100 leading-relaxed">
            テクノロジーで、アジアと地域の暮らしを豊かに
          </p>
        </div>
      </div>

      {/* Company Information */}
      <section className="py-20 md:py-24 px-6 md:px-20">
        <div className="max-w-5xl mx-auto">
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
            {companyInfo.map((info, index) => (
              <div
                key={index}
                className={`grid grid-cols-1 md:grid-cols-3 gap-6 p-8 md:p-10 ${
                  index !== companyInfo.length - 1 ? 'border-b border-gray-200' : ''
                }`}
              >
                {/* Label */}
                <div className="md:col-span-1">
                  <p className="text-sm font-medium text-gray-600 mb-2 md:mb-0">
                    {info.label}
                  </p>
                </div>

                {/* Value */}
                <div className="md:col-span-2">
                  <p className="text-base text-blue-900 whitespace-pre-line leading-relaxed">
                    {info.value}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* Map Section */}
          <div className="mt-16">
            <h2 className="text-2xl font-bold text-blue-900 mb-6">アクセス</h2>
            <div className="w-full h-96 rounded-2xl overflow-hidden shadow-lg">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3323.7234567890123!2d130.4012345!3d33.5890123!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzPCsDM1JzIwLjQiTiAxMzDCsDI0JzA0LjQiRQ!5e0!3m2!1sja!2sjp!4v1234567890123!5m2!1sja!2sjp"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="会社所在地"
              ></iframe>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
